<div class="m-switch"
     :class="{ 'm--is-switch-left': hasSwitchLeft,
                'm--is-switch-right': !hasSwitchLeft,
                'm--is-disabled': isDisabled,
                'm--is-waiting': isWaiting,
                'm--has-error': hasError,
                'm--is-valid': isValid,
                'm--is-checked': propChecked,
                'm--is-focus': isFocus,
                'm--no-state-text': !stateText }">
    <input v-model="propChecked"
           :id="id"
           class="m-switch__hidden"
           ref="switch"
           :disabled="isDisabled || isWaiting"
           type="checkbox"
           @click="onClick"
           @focus="isFocus = true"
           @blur="isFocus = false"/>
    <label class="m-switch__body"
           :for="id"
           :aria-hidden="!$slots.default">
        <span class="m-switch__input"
              aria-hidden="true">
            <span class="m-switch__button"></span>
            <span class="m-switch__text"
                  v-if="stateText">
                <template v-if="propChecked">
                    {{ $i18n.translate('m-switch:yes') }}
                </template>
                <template v-else>
                    {{ $i18n.translate('m-switch:no') }}
                </template>
            </span>
        </span>
        <span class="m-switch__label"
              v-if="$slots.default">
            <slot/>
        </span>
    </label>
    <m-validation-message :disabled="isDisabled"
                          :waiting="isWaiting"
                          :error-message="errorMessage"
                          :valid-message="validMessage"
                          :helper-message="helperMessage" />
</div>
